import { Controller } from 'stimulus';

export default class extends Controller {
  toggle() {
    Array.from(this.element.querySelectorAll('.record-archived')).forEach((el) => {
      el.classList.toggle('d-none', this.hidden);
    });
    this.hidden = !this.hidden;
  }
}
